module.exports = __webpack_public_path__ + "img/img6.cec38fa9.png";